// extracted by mini-css-extract-plugin
module.exports = {"pintxo-field-container":"Field_pintxo-field-container__X4vgk","pintxo-field-container__footer":"Field_pintxo-field-container__footer__Z30Dv"};